import when from 'when'
import Emitter from 'event-emitter'
import RAF from '@/js/utils/raf'

import GetVid from './getVid'
import ProceduralCheck from './proceduralCheck'
import WatchHands from './watchHands'
import Train from './train'
import { getGPUTier } from 'detect-gpu';
import { vec2 } from 'gl-matrix'
const _VEC2 = vec2.create()

class TensorManager {
    constructor() {
        this.rankGpu()
        this._emitter = {}
        Emitter(this._emitter)
        this.on = this._emitter.on.bind(this._emitter)
        this.off = this._emitter.off.bind(this._emitter)
        this.isWatched = false
        this.watch = new WatchHands(this)
        this.trackedHand = null
        this.everTracked = false

        // A MODIF
        if (this.GPUTier.tier == "GPU_DESKTOP_TIER_3" || this.GPUTier.tier == "GPU_MOBILE_TIER_3") {
            this.size = {
                width: 360,
                height: 240,
            }
        } else {
            this.size = {
                width: 540,
                height: 360,
            }
        }

        this.target = vec2.create()
        this.framePosition =vec2.create()
        this.frameDamp = 0.1

        this.active = true

    }

    setDom(dom) {
        this.domFeedback = dom
    }
    rankGpu() {
        this.GPUTier = getGPUTier({
            mobileBenchmarkPercentages: [0, 50, 40, 10], // (Default) [TIER_0, TIER_1, TIER_2, TIER_3]
            desktopBenchmarkPercentages: [0, 50, 40, 30], // (Default) [TIER_0, TIER_1, TIER_2, TIER_3]
        });
    }

    showFeedBack() {
        this.domFeedback.classList.remove("hidden")
    }

    hideFeedBack() {
        this.domFeedback.classList.add("hidden")
    }

    activate() {
        this.active = true
    }

    desactivate() {
        this.active = false
    }

    loadModels() {
        let loadables = []
        loadables.push(this.getHandData())
        loadables.push(this.watch.setTensor())

        when.all(loadables).then(() => {
            // this.onLoaded()
            this._emitter.emit('loaded')
            this.isLoaded = true
        })

        let percent = 0
        for (let i = 0; i < loadables.length; i++) {
            loadables[i].then(() => {
                percent++
                // console.log(loadables.length)
                this._emitter.emit('progress', Math.round((percent / loadables.length) * 100))
            })
        }
    }

    onLoaded() {
        // this._emitter.emit('loaded')

        this.playbackVideo = document.querySelector('.home-playback-video')
        this.playbackCanvas = document.querySelector('.home-playback-canvas')
        this.ctx = this.playbackCanvas.getContext("2d")
        this.resize()

        this.vid = new GetVid(this.playbackVideo, this, this.size.width, this.size.height)
        this.check = new ProceduralCheck(this.vid, this)

        this.vid.init().then(() => {
            this._emitter.emit('ready')
            this.isReady = true
            // console.log("TENSOR READY");
            this.startTracking()
        })
    }

    resize() {
        this.canvasRect = this.playbackCanvas.getBoundingClientRect()
        this.playbackCanvas.width = this.size.width
        this.playbackCanvas.height = this.size.height
    }

    resetTracking() {
        this.everTracked = false
    }

    startTracking() {
        this.watch.setVideo(this.playbackVideo)


        if (this.GPUTier.tier == "GPU_DESKTOP_TIER_3" || this.GPUTier.tier == "GPU_MOBILE_TIER_3") {
            RAF.suscribe("tensorUpdate", this.update.bind(this), 1)
        } else {
            RAF.suscribe("tensorUpdate", this.update.bind(this), 2)
        }
        this.rectSize = [this.size.width * 0.5, this.size.height *0.6]
        this.target[0] = this.size.width/2
        this.target[1] = this.size.height / 2 + this.rectSize[1]/2
        RAF.suscribe("handFrame", this.draw.bind(this))
    }

    async getHandData() {
        let response = await fetch('model/handData.json')
        let data = await response.json()
        this.handData = data
        return data
    }

    update() {

        if (this.active == false) {
            return
        }
        this.watch.hand().then((hands) => {
            if(!this.isWatched) {
                this.isWatched = true
                this._emitter.emit('isWatched')
            }
            if (hands.length > 0) {
                this.trackedHand = hands[0]
                this.trackedHand.size = this.size
                // this.drawHandsPlayback(this.trackedHand)
                this.check.getPos(this.trackedHand.annotations)
                this._emitter.emit('frame', this.trackedHand)
                if (this.everTracked == false) {
                    this.everTracked = true
                    
                    this._emitter.emit('firstTracked', this.trackedHand)
                }
            } else {
                this.trackedHand = null
            }
        })

        // this.drawHandFrame()

        // this.procedural.getPos(this.watch.handPos)
        // if (this.model && this.modelTrained) {
        //     this.predict(this.watch.landmarkPos)
        // }
    }

    draw() {
        
        this.ctx.clearRect(0, 0, this.size.width, this.size.height)
        this.drawHandFrame()
        if(this.trackedHand) this.drawHandsPlayback(this.trackedHand)
    }

    drawHandsPlayback(hand) {

        this.ctx.beginPath();
        this.ctx.strokeStyle = "#ffffff";
        this.ctx.lineWidth = 4;
        this.ctx.lineCap = "round";

        this.handPos = hand.annotations
        for (let [key, value] of Object.entries(hand.annotations)) {
            this.ctx.moveTo(value[0][0], value[0][1])
            value.map(el => {
                this.ctx.lineTo(el[0], el[1]);
                this.ctx.stroke();
            })
        }

        this.landmarkPos = []
        hand.landmarks.map(el => {
            let point = [Math.trunc(el[0] - hand.boundingBox.topLeft[0]), Math.trunc(el[1] - hand.boundingBox.topLeft[1])]
            point.map(coord => {
                this.landmarkPos.push(coord)
            })
        })

        this.ctx.closePath()
        this.ctx.beginPath()
        this.ctx.arc(hand.annotations.palmBase[0][0], hand.annotations.palmBase[0][1], 4, 0, Math.PI * 2, true)
        this.ctx.fill()
        this.ctx.fillStyle = "#ffffff";
        this.ctx.stroke()
        this.ctx.lineWidth = 4;
        this.ctx.strokeStyle = "#ffffff";
        this.ctx.closePath()

        // this.ctx.globalAlpha = 0.4
        // this.ctx.rect(3, 3, this.size.width - 12, this.size.height - 20);
        // this.ctx.fillStyle = "#000000";
        // this.ctx.fill();
    }

    drawHandFrame() {
        this.ctx.globalAlpha = 0.4
        this.ctx.rect(0, 0, this.size.width, this.size.height);
        this.ctx.fillStyle = "#000000";
        this.ctx.fill();

        this.ctx.globalAlpha = 1
        this.ctx.beginPath()
        // if(this.trackedHand ){
        //     this.target[0] = this.trackedHand.annotations.palmBase[0][0]
        //     this.target[1] = this.trackedHand.annotations.palmBase[0][1]
        // }
        vec2.sub(_VEC2, this.target , this.framePosition)
        vec2.scale(_VEC2, _VEC2, this.frameDamp)
        vec2.add(this.framePosition, this.framePosition, _VEC2)

        this.origin = [this.framePosition[0] - this.rectSize[0]*0.5, this.framePosition[1]]
        this.ctx.moveTo(this.framePosition[0] - this.rectSize[0]*0.5, this.framePosition[1])

        this.ctx.lineTo(this.origin[0], this.origin[1] - this.rectSize[1])
        this.ctx.lineTo(this.origin[0] + this.rectSize[0], this.origin[1] - this.rectSize[1])
        this.ctx.lineTo(this.origin[0] + this.rectSize[0], this.origin[1] )

        this.ctx.lineTo(this.origin[0], this.origin[1])

        this.ctx.strokeStyle = "#ffffff";
        this.ctx.stroke();
        this.ctx.lineWidth = 2;
        this.ctx.closePath()


        this.ctx.save();

        this.ctx.globalCompositeOperation = "destination-out";
        this.ctx.beginPath()

   
        this.ctx.moveTo(this.origin[0], this.origin[1])


        this.ctx.lineTo(this.origin[0], this.origin[1] - this.rectSize[1])
        this.ctx.lineTo(this.origin[0] + this.rectSize[0], this.origin[1] - this.rectSize[1])
        this.ctx.lineTo(this.origin[0] + this.rectSize[0], this.origin[1] )
        this.ctx.closePath()
        this.ctx.strokeStyle = "#ffffff";
        this.ctx.stroke();
        this.ctx.fillStyle = "#ffffff";
        this.ctx.fill()
        this.ctx.lineWidth = 2;
        // this.ctx.clip();
        this.ctx.restore();
    }

}

const out = new TensorManager()
export default out
